module.exports = __webpack_public_path__ + "img/SvenskaTriathloncupen_logo.3e238adf.png";